type PlayerOptions = {
  loop: boolean;
  autoPlay: boolean;
  enabledTitle: boolean;
  enabledControls: boolean;
};

export const generateVideoUrl = ({
  videoId,
  options: { loop, autoPlay, enabledTitle, enabledControls },
}: {
  videoId: string | undefined;
  options: PlayerOptions;
}): string | undefined => {
  if (!videoId) {
    return;
  }
  const videoUrl = new URL(`https://www.tiktok.com/player/v1/${videoId}`);
  const getParamValue = (bool: boolean) => (bool ? '1' : '0');

  videoUrl.searchParams.append('loop', getParamValue(loop));
  videoUrl.searchParams.append('autoplay', getParamValue(autoPlay));
  videoUrl.searchParams.append('controls', getParamValue(enabledControls));
  videoUrl.searchParams.append('description', getParamValue(enabledTitle));
  videoUrl.searchParams.append('rel', '1');

  return videoUrl.toString();
};

export const extractVideoIdFromUrl = (
  url: string | undefined,
): string | undefined => {
  if (!url) {
    return;
  }
  const match = url.match(/video\/(\d+)/);
  return match?.[1];
};
